import { FormGroup } from '@angular/forms';

export class SubmittableFormGroup extends FormGroup {

  /** Boolean - if form has been submitted */
  public submitted = false;

}
